import ApiService from './api.service'

const MessageService = {
  async getMessages(data = '') {
    try {
      return await ApiService.get(`messages/langs${data}`)
    } catch (error) {
      return error
    }
  },

  async listMessages(params = {}) {
    try {
      const query = new URLSearchParams()

      if (params.page) {
        query.set('page', params.page)
      }

      if (params.per_page) {
        query.set('per_page', params.per_page)
      }

      if (params.type) {
        query.set('type', params.type)
      }

      const queryString = query.toString()

      return await ApiService.get(`messages${queryString ? `?${queryString}` : ''}`)
    } catch (error) {
      return error
    }
  },

  async getMessage(id) {
    try {
      return await ApiService.get(`message/${id}/show/langs`)
    } catch (error) {
      return error
    }
  },

  async storeMessage(data) {
    try {
      return await ApiService.post(`messages`, data)
    } catch (error) {
      return error
    }
  },

  async saveMessage(data, id) {
    try {
      return await ApiService.put(`messages/${id}`, data)
    } catch (error) {
      return error
    }
  },

  async deleteMessage(id) {
    try {
      return await ApiService.delete(`messages/${id}`)
    } catch (error) {
      return error
    }
  },
}

export { MessageService }
